export const ComponentNames = Object.freeze({
  Analytics: 'Analytics',
  Flows: 'Flows',
  Dashboard: 'Dashboard',
  NLP: 'AI',
  Support: 'Support',
  Broadcasts: 'Broadcasts',
  Widget: 'Widget',
  BotSettings: 'Settings',
})
